// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3955) return "static/chunks/3955.60706f147c8c8c59.js";
	if (chunkId === 408) return "static/chunks/408.8927f0bc89f68163.js";
	if (chunkId === 9614) return "static/chunks/9614.ad7b5d16b26cb10b.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"657":"f09979b9d60f53a1","5508":"28e43c84e247cdc1","6152":"0ccbee6ffea0056c","8594":"33c10662d8630299"}[chunkId] + ".js";
};